/** Kiemelés / prioritás — backend is_list_boosted / is_priority_ranked mezők, vagy _until dátum. */

function parseUntil(raw) {
  if (!raw) return null;
  const d = new Date(String(raw).replace("Z", "+00:00"));
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isAddonActive(car, key) {
  if (!car) return false;
  if (key === "list_boost" && car.is_list_boosted) return true;
  if (key === "priority_ranking" && car.is_priority_ranked) return true;
  const until = parseUntil(car[`addon_${key}_until`]);
  return until != null && until > new Date();
}

export function listingRank(car) {
  if (isAddonActive(car, "priority_ranking")) return 1;
  return 0;
}

export function compareListingRank(a, b) {
  const diff = listingRank(b) - listingRank(a);
  if (diff !== 0) return diff;
  const ca = a.created_at || "";
  const cb = b.created_at || "";
  return cb.localeCompare(ca);
}
